import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Exit from "../container/Exit";

const Menu = (props) => {

    const renderMenu = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Menu
        </Tooltip>
      );

      const renderModulos = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Módulos
        </Tooltip>
      );

      const renderUsuarios = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Usuários
        </Tooltip>
      );

      const renderServicos = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Serviços
        </Tooltip>
      );

      const renderAdministracao = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Aministração Dommus
        </Tooltip>
      );

      const renderConfiguracoes = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Configurações
        </Tooltip>
      );

      const renderSuporte = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Suporte
        </Tooltip>
      );

      const renderSair = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Sair
        </Tooltip>
      );

    const [overlay, setOverlay] = useState(false)

    const [userWrapper, setShow] = useState(true)
    const userWrapperShow = () => {
        if (userWrapper === false) {
            setShow(true)
        } else {
            setShow(false)
        }
    }

    const [abrirMenu, setabrirMenuShow] = useState(false)
    const abrirMenuShow = () => {
        if (abrirMenu === false) {
            setabrirMenuShow(true)
        } else {
            setabrirMenuShow(false)
        }
    }

    const [abrirServico, setAbrirServico] = useState(false)
    const abrirServicoShow = () => {
        if (abrirServico === false) {
            setOverlay(true)
            setAbrirServico(true)
            setAbrirConfiguracoes(false)
            setAbrirSuporte(false)
            setAbrirAdministracao(false)
        } else {
            setAbrirServico(false)
            setOverlay(false)
        }
    }

    const [abrirAdministracao, setAbrirAdministracao] = useState(false)
    const abrirAdministracaoShow = () => {
        if (abrirAdministracao === false) {
            setOverlay(true)
            setAbrirAdministracao(true)
            setAbrirServico(false)
            setAbrirConfiguracoes(false)
            setAbrirSuporte(false)
        } else {
            setAbrirAdministracao(false)
            setOverlay(false)
        }
    }

    const [abrirConfiguracoes, setAbrirConfiguracoes] = useState(false)
    const abrirConfiguracoesShow = () => {
        if (abrirConfiguracoes === false) {
            setOverlay(true)
            setAbrirConfiguracoes(true)
            setAbrirServico(false)
            setAbrirSuporte(false)
            setAbrirAdministracao(false)
        } else {
            setAbrirConfiguracoes(false)
            setOverlay(false)
        }
    }

    const [abrirSuporte, setAbrirSuporte] = useState(false)
    const abrirSuporteShow = () => {
        if (abrirSuporte === false) {
            setOverlay(true)
            setAbrirSuporte(true)
            setAbrirServico(false)
            setAbrirConfiguracoes(false)
            setAbrirAdministracao(false)
        } else {
            setAbrirSuporte(false)
            setOverlay(false)
        }
    }

    return (
        <>
            {props.menu ?
                <>
                    <div className={`sidenav-overlay ${overlay ? 'open' : ''}`}></div>
                    <div className="allsidebar ">
                        <aside className={`sidebar ${userWrapper ? 'hide' : ''}`}>
                            <div className={`sidebar-wrapper ${userWrapper ? 'is-closed' : ''}`}>
                                <div className="sidebar-title">
                                    <span>Menu</span>
                                    <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderMenu}
                                    >
                                    <Link onClick={userWrapperShow} to="#" data-toggle="tooltip" data-placement="right" title=""
                                        data-original-title="Ocultar Menu">
                                        <i className="fas fa-stream"></i>
                                    </Link>
                                    </OverlayTrigger>
                                </div>
                                <div className="siderbar-holder">
                                    <div className="menu-structure is-overflow">
                                        <header onClick={abrirMenuShow} className={`is-toggle is-menu ${abrirMenu ? 'arrow' : ''}`}>
                                            Controle de Dados
                                        </header>
                                        <ul style={{ display: abrirMenu ? 'none' : 'block' }}>
                                            <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderModulos}
                                            >
                                                <Link to="/menu/" data-toggle="tooltip" data-placement="right">
                                                    <i className="fas fa-table"></i>
                                                    <p>Módulos</p>
                                                </Link>
                                            </OverlayTrigger>
                                            </li>
                                            <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderUsuarios}
                                            >
                                                <Link to="/usuarios" data-toggle="tooltip" data-placement="right">
                                                    <i className="fas fa-users"></i>
                                                    <p>Usuários</p>
                                                </Link>
                                            </OverlayTrigger>
                                            </li>
                                            <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderServicos}
                                            >
                                                <Link onClick={abrirServicoShow} to="#" data-toggle="tooltip" data-placement="right">
                                                <i className="fab fa-servicestack"></i>
                                                    <p>Serviço</p>
                                                </Link>
                                            </OverlayTrigger>
                                            </li>
                                            <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderAdministracao}
                                            >
                                                <Link onClick={abrirAdministracaoShow} to="#" data-toggle="tooltip" data-placement="right">
                                                <i className="fab fa-buromobelexperte"></i>
                                                    <p>Aministração Dommus</p>
                                                </Link>
                                            </OverlayTrigger>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="info-structure">
                                        <ul>
                                            <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderConfiguracoes}
                                            >
                                            <Link onClick={abrirConfiguracoesShow} to="#" id="abrir-configuracoes" data-toggle="tooltip" data-placement="right">
                                                    <i className="fas fa-user-cog"></i>
                                                    <p>Configurações</p>
                                            </Link>
                                            </OverlayTrigger>
                                            </li>
                                            <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={renderSuporte}
                                            >
                                                <Link onClick={abrirSuporteShow} to="#" id="abrir-suporte" data-toggle="tooltip" data-placement="right">
                                                    <i className="fas fa-info-circle"></i>
                                                    <p>Suporte</p>
                                                </Link>
                                                </OverlayTrigger>
                                            </li>
                                            <li>
                                                <Exit menu={true} renderSair={renderSair} />
                                            </li>
                                        </ul>
                                        <div className="copy">
                                            Copyright © 2020 <Link to="#">Dommus Sistemas</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                        <div className="menu-sections" style={{ display: 'block' }}>
                            <section className={`servicos configuracoes is-menu ${abrirServico ? 'open' : ''}`} style={{ left: userWrapper ? '49px' : '249px' }}>
                                <header>
                                    Serviços
                                    <div className="close-pane" onClick={abrirServicoShow}>
                                        <i className="fas fa-arrow-left"></i>
                                    </div>
                                </header>
                                <ul className="dados-usuario">
                                    <li>
                                        <Link to="/ccd">
                                            <p><i className="fas fa-blender-phone"></i>Central de Comunicação</p>
                                            <i className="fas fa-chevron-right"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </section>
                            <section className={`aministracao configuracoes is-menu ${abrirAdministracao ? 'open' : ''}`} style={{ left: userWrapper ? '49px' : '249px' }}>
                                <header>
                                    Aministração Dommus
                                    <div className="close-pane" onClick={abrirAdministracaoShow}>
                                        <i className="fas fa-arrow-left"></i>
                                    </div>
                                </header>
                                <ul className="dados-usuario">
                                    <li>
                                        <Link to="/administracao/cliente">
                                            <p><i className="fas fa-user-tie"></i>Gestão de Clientes</p>
                                            <i className="fas fa-chevron-right"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </section>
                            <section className={`suporte is-menu ${abrirSuporte ? 'open' : ''}`} style={{ left: userWrapper ? '49px' : '249px' }}>
                                <header>
                                    Suporte
                                    <div className="close-pane" onClick={abrirSuporteShow}>
                                        <i className="fas fa-arrow-left"></i>
                                    </div>
                                </header>
                                <h6>Telefones:</h6>
                                <ul className="telefones">
                                    <li>
                                        <Link to="tel:+55 31 38899776"><i className="fas fa-headphones-alt"></i>
                                            <p>31 3889 - 9776</p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="tel:+55 31 984895755"><i className="fab fa-whatsapp"></i>
                                            <p>31 98489 - 5755</p>
                                        </Link>
                                    </li>
                                </ul>
                                <h6>Email:</h6>
                                <ul className="email">
                                    <li>
                                        <Link to="mailto:comercial@dommus.com.br">
                                            <i className="fas fa-envelope"></i>
                                            <p>comercial@dommus.com.br</p>
                                        </Link>
                                    </li>
                                </ul>
                                <h6>Redes Sociais:</h6>
                                <ul className="redes-sociais">
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-facebook-square"></i>
                                            <p>Facebook</p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.linkedin.com/company/dommus-sistemas/">
                                            <i className="fab fa-linkedin"></i>
                                            <p>LinkedIn</p>
                                        </Link>
                                    </li>
                                </ul>
                                <h6>Site:</h6>
                                <ul className="website">
                                    <li>
                                        <Link to="#">
                                            <i className="fab fa-chrome"></i>
                                            <p>Website</p>
                                        </Link>
                                    </li>
                                </ul>
                            </section>
                            <section className={`configuracoes is-menu ${abrirConfiguracoes ? 'open' : ''}`} style={{ left: userWrapper ? '49px' : '249px' }}>
                                <header>
                                    Configurações
                                    <div className="close-pane" onClick={abrirConfiguracoesShow}>
                                        <i className="fas fa-arrow-left"></i>
                                    </div>
                                </header>
                                <ul className="dados-usuario">
                                    <li>
                                        <Link to="#">
                                            <p><i className="fas fa-users-cog"></i>Permissões</p>
                                            <i className="fas fa-chevron-right"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </section>
                        </div>
                    </div>
                    <div className="dommus-content" style={{ width: userWrapper ? 'calc(100% - 50px)' : 'calc(100% - 255px)' }}>
                        {props.html}
                    </div>
                </> :
                <div className="dommus-content" style={{ width: 'calc(100% - 0px)' }}>
                    {props.html}
                </div>
            }
        </>
    );
};

export default Menu;